// src/components/Projects/ErrorAlert.jsx

import React from "react";

const ErrorAlert = ({ error }) => {
  if (!error) return null;

  return (
    <div
      className="bg-red-100 text-red-700 p-4 rounded mb-6"
      role="alert"
      aria-live="assertive"
    >
      {error}
    </div>
  );
};

export default ErrorAlert;
